module.exports = __webpack_public_path__ + "static/media/TA274_5.e637dba1.png";